<template>
  <overlay-scrollbars :options="{ className: 'custom-scrollbar os-theme-dark', scrollbars: { visibility: 'auto', autoHide: 'leave', autoHideDelay: 400, dragScrolling: true, clickScrolling: false, touchSupport: true, snapHandle: false } }">
    <form @submit.prevent="handleSubmit">
      <div class="modal-window-header gray">
        <div class="modal-window-heading">
          <h3 class="icon-heading small">
            <span class="icon"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-person"></use></svg></span>
            <span v-if="kunde.Bedrift && kunde.FirmaNavn">{{kunde.FirmaNavn}}<span class="opacity-60" v-if="kunde.full_name"> ({{kunde.full_name}})</span></span>
            <span v-else>{{kunde.full_name}}</span>
          </h3>
        </div>
      </div>

      <div class="modal-window-body">
        <fieldset>
          <div class="grid-x grid-padding-x">
              <div class="cell large-12">
                <ul class="switch-list">
                  <TheSwitchListSwitchInput v-model="form.kyc_sent" labelTrue="The KYC form was sent to the customer" labelFalse="The KYC form was sent to the customer"/>
                </ul>
              </div>

              <div class="cell large-12"><br></div>

              <div class="cell large-6">
                <label for="kyc_exceeded">KYC exceded amount</label>
                <div class="input-container date" :class="{'form-error': errors.has('kyc_exceeded')}">
                  <b-datepicker
                    :show-week-number="false"
                    :editable="false"
                    :first-day-of-week="1"
                    :disabled="true"
                    v-model="form.kyc_exceeded"
                    name="kyc_exceeded"
                    placeholder="Vis kalender..."
                    icon="calendar-today"
                    ref="kyc_exceeded"
                    id="kyc_exceeded">
                    <button class="button disabled" v-if="!form.kyc_exceeded" @click.prevent="$refs.kyc_exceeded.toggle()"><span>Slett dato</span></button>
                    <button class="button" v-else @click.prevent="form.kyc_exceeded = null"><span>Slett dato</span></button>
                  </b-datepicker>
                  <span class="glyph"><svg viewBox="0 0 44 44"><use xlink:href="/static/sprites.svg#glyph-input-date"></use></svg></span>
                  <span class="form-error-label" v-if="errors.has('kyc_exceeded')">
                    <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-error"></use></svg>
                    {{errors.first('kyc_exceeded')}}
                  </span>
                </div>
              </div>

              <div class="cell large-6">
                <label for="kyc_filled">KYC form filled</label>
                <div class="input-container date" :class="{'form-error': errors.has('kyc_filled')}">
                  <b-datepicker
                    :show-week-number="false"
                    :editable="false"
                    :first-day-of-week="1"
                    v-model="form.kyc_filled"
                    name="kyc_filled"
                    placeholder="Vis kalender..."
                    icon="calendar-today"
                    ref="kyc_filled"
                    id="kyc_filled">
                    <button class="button disabled" v-if="!form.kyc_filled" @click.prevent="$refs.kyc_filled.toggle()"><span>Slett dato</span></button>
                    <button class="button" v-else @click.prevent="form.kyc_filled = null"><span>Slett dato</span></button>
                  </b-datepicker>
                  <span class="glyph"><svg viewBox="0 0 44 44"><use xlink:href="/static/sprites.svg#glyph-input-date"></use></svg></span>
                  <span class="form-error-label" v-if="errors.has('kyc_filled')">
                    <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-error"></use></svg>
                    {{errors.first('kyc_filled')}}
                  </span>
                </div>
              </div>
          </div>
        </fieldset>
      </div>

      <div class="modal-window-footer">
        <div class="grid-x">
          <div class="cell align-right">
            <a v-if="!$store.getters.isFormProcessing" href="javascript:;" @click="closeButtonClick()" class="button primary transparent large modal-close show-for-medium">Avbryt</a>
            <a v-else href="javascript:;" class="button primary transparent large modal-close show-for-medium">Avbryt</a>

            <a v-if="$store.getters.isFormSubmittable" href="javascript:;" @click="submitButtonClick()" class="button primary submit large">Lagre</a>
            <a v-if="$store.getters.isFormProcessing" href="javascript:;" class="button primary submit large loading">Lagrer...<span class="loader-spinner"></span></a>
            <a v-if="$store.getters.isFormLoading" href="javascript:;" class="button primary submit large" disabled>Lagre</a>
          </div>
        </div>
      </div>

      <a href="javascript:;" class="modal-close modal-window-close-button" @click="closeButtonClick()">
        <span>Lukk</span>
        <svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-close"></use></svg>
      </a>
    </form>
  </overlay-scrollbars>
</template>

<script>
import KundeService from '@/services/KundeService'
import bus from '@/plugins/event-bus'

export default {
  name: 'KundeKycModal',
  $_veeValidate: {
    validator: 'new'
  },
  props: {
    kundeId: {
      type: [Number],
      required: true
    },
    event: {
      type: String,
      required: false,
      default: () => {
        return 'kunde-address-updated'
      }
    }
  },
  data () {
    return {
      form: {},
      kunde: {}
    }
  },
  computed: {
    hasOnePhone: function () {
      if (this.form.Tlfprivat || this.form.Tlfarbeid || this.form.Mobil) {
        return true
      }

      return false
    }
  },
  watch: {
    // Watch for changes in the kunde object
  },
  created () {
    // Set form to loading
    this.setFormLoading(true)

    this.init(false)

    // Load data needed in the form
    this.fetch()
  },
  methods: {
    init: function () {
      if (!this.kundeId) {
        this.$helpers.showErrorAlert('Feil', 'Objekt ikke funnet')
        this.closeModal()
        return
      }

      this.loadKundeById(this.kundeId)
    },
    loadKundeById: function (id) {
      KundeService.view(id)
        .then(response => {
          // Setup everything
          this.kunde = response.data

          // Make the form object
          this.makeFormItem()

          this.setFormLoading(false)
        })
        .catch(error => {
          console.log('Error')
          console.log(error)
          this.$helpers.showErrorAlert('Feil', 'Kunde ikke funnet')
          this.closeModal()
        })
    },
    makeFormItem: function () {
      // Clone kunde to the form object
      this.form = this._.cloneDeep(this.kunde)

      if (this.form.kyc_exceeded) {
        this.form.kyc_exceeded = new Date(Date.parse(this.form.kyc_exceeded))
      }

      if (this.form.kyc_filled) {
        this.form.kyc_filled = new Date(Date.parse(this.form.kyc_filled))
      }
    },
    fetch: function () {
      // Load data needed in the form
    },
    closeButtonClick: function () {
      if (!this.$store.getters.isFormProcessing) {
        this.setFormLoading(false)
        this.$emit('close')
      }
    },
    submitButtonClick: function () {
      this.handleSubmit()
    },
    handleSubmit: function () {
      if (!this.isFormSubmittable()) {
        return
      }

      this.setFormProcessing(true)

      this.$validator.validateAll()
        .then((result) => {
          if (!result) {
            // Validation Failed
            this.setFormProcessing(false)
            this.$helpers.showErrorAlert('Kunne ikke lagre endringer', 'Vennligst korriger feil i skjemaet')
          } else {
            // No errors, so try to save
            let kundenr = this.kunde.Kundenr || null

            KundeService.save(kundenr, this.form)
              .then((response) => {
                this.$emit('close')
                bus.$emit(this.event, response.data)
              })
              .catch((error) => {
                // Put API errors into the error container
                this.$helpers.sendApiErrorsToValidator(error, this.errors)

                // Check if new errors appeared
                if (this.errors.any()) {
                  this.$validator.resume()
                  this.$helpers.showErrorAlert('Kunne ikke lagre endringer', 'Vennligst korriger feil i skjemaet')
                } else {
                  this.$helpers.showErrorAlert('Kunne ikke lagre endringer', 'Vennligst prøv igjen', 2500)
                }
              })
              .then(() => {
                this.setFormProcessing(false)
              })
          }
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/KundeKycModal.vue